import React from 'react';
import { Box, Typography } from '@mui/material';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import bannerBg from '../assets/img/driver2.jpg';

/**
 * Dashboard page hero strip — Conecta2 style.
 * Uses driver2.jpg as the franja background.
 */
export default function DashboardPageBanner({
  title,
  titleAccent,
  subtitle,
  tagline = 'TU VEHÍCULO\nNUEVAS OPORTUNIDADES',
  icon: Icon = DirectionsCarOutlinedIcon,
}) {
  const tagLines = String(tagline).split('\n');
  const titleStr = String(title || '');
  const accent = titleAccent ? String(titleAccent) : '';
  const accentIdx = accent ? titleStr.toUpperCase().lastIndexOf(accent.toUpperCase()) : -1;
  const titleBefore = accentIdx >= 0 ? titleStr.slice(0, accentIdx) : titleStr;
  const titleHighlight = accentIdx >= 0 ? titleStr.slice(accentIdx, accentIdx + accent.length) : '';
  const titleAfter = accentIdx >= 0 ? titleStr.slice(accentIdx + accent.length) : '';

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: { xs: 120, sm: 140 },
        borderRadius: { xs: '12px', sm: '16px' },
        overflow: 'hidden',
        mb: 2,
        backgroundColor: '#2A1850',
        backgroundImage: `url(${bannerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: '78% center',
        backgroundRepeat: 'no-repeat',
        boxShadow: '0 10px 28px rgba(26, 15, 59, 0.22)',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(90deg, rgba(26,15,59,0.88) 0%, rgba(44,25,91,0.62) 38%, rgba(26,15,59,0.22) 68%, rgba(26,15,59,0.08) 100%)',
          zIndex: 1,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 2.5 },
          minHeight: { xs: 120, sm: 140 },
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 }, minWidth: 0 }}>
          <Box
            sx={{
              width: { xs: 44, sm: 52 },
              height: { xs: 44, sm: 52 },
              borderRadius: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(100, 17, 237, 0.28)',
              border: '1px solid rgba(118, 40, 255, 0.55)',
              boxShadow: '0 0 18px rgba(100, 17, 237, 0.35)',
              flexShrink: 0,
            }}
          >
            <Icon sx={{ color: '#FBFAFE', fontSize: { xs: 26, sm: 30 } }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontFamily: "'Outfit', 'Poppins', sans-serif",
                fontWeight: 800,
                fontSize: { xs: '1.45rem', sm: '1.85rem' },
                color: '#FBFAFE',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                lineHeight: 1.1,
                textShadow: '0 2px 12px rgba(0,0,0,0.35)',
              }}
            >
              {titleBefore}
              {titleHighlight ? (
                <Box component="span" sx={{ color: '#B794FF' }}>{titleHighlight}</Box>
              ) : null}
              {titleAfter}
            </Typography>
            {subtitle ? (
              <Typography
                sx={{
                  mt: 0.6,
                  fontFamily: "'Outfit', 'Poppins', sans-serif",
                  fontSize: { xs: '12px', sm: '14px' },
                  color: 'rgba(251,250,254,0.88)',
                  lineHeight: 1.4,
                  maxWidth: 420,
                }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            alignItems: 'flex-end',
            flexShrink: 0,
            pr: 1,
          }}
        >
          {tagLines.map((line) => (
            <Typography
              key={line}
              sx={{
                fontFamily: "'Outfit', 'Poppins', sans-serif",
                fontWeight: 700,
                fontSize: '11px',
                letterSpacing: '1.6px',
                textTransform: 'uppercase',
                color: '#FBFAFE',
                lineHeight: 1.35,
                textAlign: 'right',
              }}
            >
              {line}
            </Typography>
          ))}
          <Box
            sx={{
              mt: 0.8,
              width: 56,
              height: 3,
              borderRadius: 2,
              background: 'linear-gradient(90deg, #6411ED, #7628FF)',
              boxShadow: '0 0 10px rgba(118,40,255,0.5)',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
